'use strict';

var BaseGroup = require('config/Group');
var RenderPositions = require('config/RenderPositions');
var i18n = require('i18next');

/**
 * "Web Filters" configuration group.
 */
module.exports = BaseGroup.extend({
  actionList: [
    {
      name: 'webFilters',
      position: RenderPositions.full,
      required: true,
      renderTitle: false,
      renderStatic: true,
      doubleWide: false,
    },
    {
      name: 'domainFilters',
      position: RenderPositions.full,
      required: true,
      renderTitle: true,
      renderStatic: true,
      doubleWide: false,
    },
  ],

  skipTasksWithNoChange: ['webFilters.setOptions'],

  /**
   * @return {Boolean}
   */
  isRequired: function() {
    return true;
  },

  /**
   * @return {String}
   */
  title: function() {
    return i18n.t('groups.webFilters');
  },
});
